import { Routes } from '@angular/router';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { ClearanceComponent } from './clearance.component';
import { ClearanceOverviewComponent } from './overview/clearance-overview.component';
import { AddEditClearanceComponent } from './add-edit-clearance/add-edit-clearance.component';
import { ViewClearanceComponent } from './view-clearance/view-clearance.component';
import { ClearanceServicesComponent } from './services/clearance-services.component';
import { AddEditClearanceServicesComponent } from './services/add-edit-services/add-edit-clearance-services.component';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';

export const clearanceRoutes: Routes = [
    {
        path: 'clearance',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['CUSTOMS_CLEARANCE'], enterpriseFeatureLabel: 'Customs Clearance' },
        children: [
            {
                path: '',
                component: ClearanceOverviewComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.clearance.records.view },
            },
            {
                path: 'list',
                component: ClearanceComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.clearance.records.view },
            },
            {
                path: 'add',
                component: AddEditClearanceComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.clearance.records.create },
            },
            {
                path: 'edit/:id',
                component: AddEditClearanceComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.clearance.records.edit },
            },
            {
                path: 'view/:id',
                component: ViewClearanceComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.clearance.records.view },
            },
            {
                path: 'services',
                children: [
                    {
                        path: '',
                        component: ClearanceServicesComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.clearance.services.view },
                    },
                    {
                        path: 'add',
                        component: AddEditClearanceServicesComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.clearance.services.create },
                    },
                    {
                        path: 'edit/:id',
                        component: AddEditClearanceServicesComponent,
                        canActivate: [PermissionGuard],
                        data: { permission: app_permissions.clearance.services.edit },
                    }
                ]
            },
        ]
    },
];
